import NumberDisplay from 'src/javascripts/components/utilities/NumberDisplay';
import {filterTypeahead} from 'src/javascripts/components/typeaheads/TypeaheadBloodhounds';
import {noResultsTemplate, emptyTemplate, logoTemplate, genericDisplayTemplate} from 'src/javascripts/components/typeaheads/TypeaheadTemplates';
import 'src/javascripts/vendor/typeahead.jquery';
import 'src/javascripts/vendor/bloodhound';
import Spinner from 'src/javascripts/components/utilities/Spinner';

// Must define Bloodhound explicitly here
// https://stackoverflow.com/questions/30750916/how-to-reference-typeahead-and-bloodhound-when-loading-npm-typeahead-js
const Bloodhound = require('src/javascripts/vendor/bloodhound');

export default function() {

  // Number display
  NumberDisplay();

  // Auto focus on typeahead when open a dropdown
  $('.dropdown').on('shown.bs.dropdown', function () {
    let input = $(this).find('input');
    if (typeof input !== 'undefined') {
      input.focus();
    }
  })

  // Set subindustry typeahead
  filterTypeahead('.sub-industry-filter', 'sub_industries', '/companies/attrs/search?attr=sub_industry&', 955, 'generic');

  // On blur
  $('.filter-companies-typeahead').bind('typeahead:beforeselect typeahead:autocomplete', function(ev, suggestion) {
    ev.preventDefault();
    $('.tooltip').tooltip('hide');
    let hiddenField = $(this).closest('.form-group').find('input[type=\'hidden\']');
    let subIndustry = suggestion.value.split(' - ').pop();
    hiddenField.val(subIndustry);
    $(this).typeahead('val', subIndustry);
    $(this).blur();
  });



}